export function getVaProExportFilename(filename) {
  const rawName = (filename || 'video').toString();
  const baseName = rawName.replace(/\.[^/.]+$/, '') || rawName || 'video';
  const sanitizedName = baseName
    .replace(/[\\/:*?"<>|\x00-\x1f]/g, '_')
    .replace(/\s+/g, '_')
    .replace(/^\.+/, '_')
    .substring(0, 100);

  return `${sanitizedName || 'video'}_VA PRO.csv`;
}
